<template>

<core-modal v-on:close="onClose">

	<template v-slot:head>

		Remove boost

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to remove daily group syncs from this group?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="red" :loading="is.loading" v-on:click.native="onConfirmClick">Confirm</core-button>
		<core-button theme="blue" v-on:click.native="onClose">Nevermind</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	methods: {

        onConfirmClick: function() {

            this.is.loading = true

            this.$api.delete('session/groupsyncs').then(function(json) {

                if (json.group) this.$store.commit('session/group', json.group)

                this.$pubsub.$emit('session.patreon.syncs')

                this.$emit('close')

            }.bind(this))

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.group {
    margin-bottom: 20px;
    display: block;
    cursor: pointer;
}

.groups-empty {
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    padding: 20px 0px;
}

.group:last-child {
    margin-bottom: 0px;
}

.group-name {
    border-radius: 4px;
    padding: 10px 30px 10px 10px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.25);
}

.group.is-selected .group-name {
    background-color: #48bb6d;
}

.group:hover .group-name {
    background-color: rgba(0, 0, 0, 0.45);
}

.group.is-selected:hover .group-name {
    background-color: #48bb6d;
}

.group-name i {
    position: absolute;
    right: 15px;
    top: 0px;
    line-height: 36px;
}

.group-metrics {
    display: grid;
    margin-top: 4px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 4px;
}

.group-metrics-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.25);
    justify-content: center;
    padding: 10px 0px;
    border-radius: 4px;
}

.group-metrics-item i {
    font-size: 14px;
    color: #fff;
    opacity: 0.75;
}

.group-metrics-item span {
    font-size: 18px;
    color: #fff;
    font-weight: 400;
    margin-bottom: 8px;
}

</style>